import React from 'react';
import { Container } from './styles';

const Loader = () => {
  return (
    <Container />
  );
};

export default Loader;